'use strict';

angular.module('enervexSalesappApp').controller('TabularDuctDatasCtrl', function($scope, TabularDuctData, _) {
	$scope.all = [];
	$scope.offset = 0;
	$scope.limit = 100;
	$scope.term = '';
	function fetch() {
		TabularDuctData.query({
			offset: $scope.offset,
			limit: $scope.limit
		}).$promise.then(function(items) {
			if (items.length > 0) {
				$scope.all = $scope.all.concat(items);
				$scope.offset = $scope.offset + $scope.limit;
				fetch();
			} else {
				$scope.all = _.sortBy($scope.all, 'code');
				$scope.applyFilter();
			}
		});
	}
	fetch();
	$scope.applyFilter = function() {
		var reg = ($scope.term && $scope.term != '') ? new RegExp(_.escapeRegExp($scope.term), "i") : null;
		$scope.items = _.filter($scope.all, function(item) {
			return !reg || reg.test(item.code) || reg.test(item.ventbomCode);
		});
	};
	$scope.size = function(item) {
		return (item.rows || []).length + " rows x " + (item.columns || []).length + " columns";
	};
});
